import ContractsMileageListParams, {
  ContractsMileageListParamsOrder,
} from "../../../../../common/services/contracts/mileage/list/contracts-mileage-list-params";
import MileageContractListingFilter from "./types/mileage-contract-listing-filter";
import MileageContractListingFilterType from "./types/mileage-contract-listing-filter-type";
import MileageContractListingSortKey from "./types/mileage-contract-listing-sort-key";

const createOrder = (
  sortKey: MileageContractListingSortKey | null,
): ContractsMileageListParamsOrder | undefined => {
  switch (sortKey) {
    case MileageContractListingSortKey.COMPANY_NAME_ASC:
      return ContractsMileageListParamsOrder.COMPANY_NAME_ASC;
    case MileageContractListingSortKey.COMPANY_NAME_DESC:
      return ContractsMileageListParamsOrder.COMPANY_NAME_DESC;
    case MileageContractListingSortKey.VALID_SINCE_ASC:
      return ContractsMileageListParamsOrder.VALID_SINCE_ASC;
    case MileageContractListingSortKey.VALID_SINCE_DESC:
      return ContractsMileageListParamsOrder.VALID_SINCE_DESC;
    case MileageContractListingSortKey.VALID_TO_ASC:
      return ContractsMileageListParamsOrder.VALID_TO_ASC;
    case MileageContractListingSortKey.VALID_TO_DESC:
      return ContractsMileageListParamsOrder.VALID_TO_DESC;
    default:
      return undefined;
  }
};

const create = (
  page: number,
  pageSize: number,
  filters: MileageContractListingFilter[],
  sortKey: MileageContractListingSortKey | null,
): ContractsMileageListParams => {
  return {
    page: page,
    pageSize: pageSize,
    order: createOrder(sortKey),
    cargoCompanyName:
      filters.find(
        (filter) =>
          filter.type == MileageContractListingFilterType.CARGO_COMPANY,
      )?.value ?? undefined,
  };
};

const mileageContractListingLoadParamsFactory = {
  create,
};

export default mileageContractListingLoadParamsFactory;
